import { memo } from 'react';

import { PublicAnnotationComment } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/AnnotationAvatarContainer/components/PublicAnnotationComment';
import { PublicAnnotationsAvatars } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/components/PublicAnnotationsAvatars';
import { useCanAnnotateCentralizedPublicClip } from '~/components/AnnotationsV2/hooks/useCanAnnotateCentralizedPublicClip';
import { PublicFloatingCommentForm } from '~/components/AnnotationsV2/shared/PublicFloatingCommentForm';
import { ImageVisualizer } from '~/components/AssetModalV2/Visualizer/ImageVisualizer/ImageVisualizer';

export const PublicImageVisualizer = memo(() => {
  const { canEditAnnotation } = useCanAnnotateCentralizedPublicClip();

  return (
    <ImageVisualizer
      AnnotationsAvatars={PublicAnnotationsAvatars}
      AnnotationComment={PublicAnnotationComment}
      FloatingCommentForm={PublicFloatingCommentForm}
      canAnnotateClip={canEditAnnotation}
    />
  );
});

PublicImageVisualizer.displayName = 'PublicImageVisualizer';
